/*
 * @Author: atdow
 * @Date: 2024-01-08 14:41:16
 * @LastEditors: null
 * @LastEditTime: 2025-09-04 09:39:54
 * @Description: file description
 */
import createAxios from '/@/utils/axios'

/**
 * 获取权限
 * @returns
 * @link http://192.168.16.90:5817/receipt-lite/doc.html#/default/%E5%89%8D%E5%8F%B0%E7%94%A8%E6%88%B7%E6%9D%83%E9%99%90%E7%AE%A1%E7%90%86/getMenuTreePermissionsUsingPOST
 */
export function getUserPermission (): ApiPromise {
  return createAxios({
    url: '/user/permissions/menu',
    method: 'POST'
  }) as ApiPromise
}

// 获取用户菜单
export function getUserMenuList (): ApiPromise {
  return createAxios({
    url: '/menu/nav',
    method: 'GET'
  }) as ApiPromise
}

// 获取区域权限
export function getRegionPermission (): ApiPromise {
  return createAxios({
    url: '/user/permissions/area',
    method: 'POST'
  }) as ApiPromise
}

// 获取区域树权限
export function getRegionTreePermission (): ApiPromise {
  return createAxios({
    url: '/user/permissions/area/tree',
    method: 'POST'
  }) as ApiPromise
}

// 获取时间权限
export function getTimePermission (): ApiPromise {
  return createAxios({
    url: '/user/permissions/date',
    method: 'POST'
  }) as ApiPromise
}

/**
 * 获取品牌权限 - 分页
 * @param data
 * @returns
 */
export function getBrandPermission (data: anyObj): ApiPromise {
  return createAxios({
    url: '/user/permissions/brand',
    method: 'POST',
    data
  }) as ApiPromise
}

/**
 * 获取品类权限 - 分页
 * @param data
 * @returns
 */
export function getCategoryPermission (data: anyObj): ApiPromise {
  return createAxios({
    url: '/user/permissions/category',
    method: 'POST',
    data
  }) as ApiPromise
}

/**
 * 获取品类树权限 - 分页
 * @param data
 * @returns
 */
export function getCategoryTreePermission (): ApiPromise {
  return createAxios({
    url: '/user/permissions/category/tree',
    method: 'POST'
  }) as ApiPromise
}


/**
 * 获取品牌下的品规权限 - 分页
 * @param data
 * @returns
 */
export function getSpecOfBrandPermission (data: anyObj): ApiPromise {
  return createAxios({
    url: '/user/permissions/brandSpec',
    method: 'POST',
    data
  }) as ApiPromise
}

/**
 * 获取品牌-品规权限 - 分页
 * @param data
 * @returns
 * @link http://192.168.16.90:5817/receipt-lite/doc.html#/default/%E5%89%8D%E5%8F%B0%E7%94%A8%E6%88%B7%E6%9D%83%E9%99%90%E7%AE%A1%E7%90%86/getBrandSpecDetailPermissionsUsingPOST
 */
export function getBrandSpecPermission (data: anyObj): ApiPromise {
  return createAxios({
    url: '/user/permissions/brandSpec/detail',
    method: 'POST',
    data
  }) as ApiPromise
}

/**
 * 获取品牌-品规(多品类)权限 - 分页
 * @param data
 * @returns
 * @link http://192.168.16.90:56225/receipt-lite/doc.html#/default/%E5%89%8D%E5%8F%B0%E7%94%A8%E6%88%B7%E6%9D%83%E9%99%90%E7%AE%A1%E7%90%86/getPageBrandSpecUsingPOST
 */
export function getBrandSpecOfMultiCategoryPermission (data: anyObj): ApiPromise {
  return createAxios({
    url: '/user/permissions/brandSpec/search',
    method: 'POST',
    data
  }) as ApiPromise
}

/**
 * 获取品牌-品规(日服用量)权限 - 分页
 * @param data
 * @param data.filterUserSku boolean 过滤只有【自定义日服用量】的品牌列表
 * @returns
 * @link http://192.168.16.90:30310/receipt-lite/doc.html#/default/%E5%89%8D%E5%8F%B0%E7%94%A8%E6%88%B7%E6%9D%83%E9%99%90%E7%AE%A1%E7%90%86/getPageSkuPermissionsUsingPOST
 */
export function getBrandSpecDailyDosagePermission (data: anyObj): ApiPromise {
  return createAxios({
    url: '/user/permissions/brandSpec/sku/search',
    method: 'POST',
    data
  }) as ApiPromise
}

/**
 * 获取通用权限（通用名、品名、剂型） - 分页  --> 品类必传
 * @param data
 * @returns
 * @link http://192.168.16.90:5817/receipt-lite/doc.html#/default/%E5%89%8D%E5%8F%B0%E7%94%A8%E6%88%B7%E6%9D%83%E9%99%90%E7%AE%A1%E7%90%86/getCommonFieldValuesPermissionsUsingPOST
 */
export function getCommonFieldPermission (data: anyObj): ApiPromise {
  return createAxios({
    url: '/user/permissions/category/common/field/values',
    method: 'POST',
    data
  }) as ApiPromise
}

/**
 * 获取通用权限（通用名、品名、剂型）（多品类） - 分页
 * @param data
 * @returns
 * @link
 */
export function getCommonFieldOfMultiCategoryPermission (data: anyObj): ApiPromise {
  return createAxios({
    url: '/user/permissions/category/common/field/values/search',
    method: 'POST',
    data
  }) as ApiPromise
}

/**
 * 获取门店等级权限 - 分页
 * @param data
 * @returns
 */
export function getStoreLevelPermission (data: anyObj): ApiPromise {
  return createAxios({
    url: '/user/permissions/store',
    method: 'POST',
    data
  }) as ApiPromise
}

/** 是否需展示升级说明弹窗，true 表示需弹窗（如首次登录） */
export function getUpdatePopupStatus (): ApiPromise<boolean> {
  return createAxios({
    url: '/user/permissions/popup/status',
    method: 'POST'
  }) as ApiPromise<boolean>
}

/** 用户已查看升级说明弹窗，无请求体 */
export function confirmUpdatePopup (): ApiPromise<unknown> {
  return createAxios({
    url: '/user/permissions/popup/confirm',
    method: 'POST'
  }) as ApiPromise
}

